import { CoreMenu } from '@core/types';

/** Hub : pas de menu métier (login / home uniquement). */
export const menu: CoreMenu[] = [];
